// The Wavelength brand mark (HD vector, from the brand package). Inherits the
// surrounding text color via currentColor, so it works on light and dark.
function WavelengthLogo({ className = '' }) {
    return (
        <svg
            viewBox="260.8 255.3 507.4 507.4"
            className={className}
            role="img"
            aria-label="Wavelength"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill="currentColor"
                d="M 578 294 L 593 297 L 605 307 L 718 489 L 720 496 L 720 508 L 718 516 L 696 571 L 689 578 L 682 581 L 668 581 L 659 577 L 652 570 L 633 538 L 628 533 L 608 578 L 583 642 L 576 649 L 565 653 L 554 652 L 547 649 L 538 641 L 515 604 L 513 606 L 512 611 L 497 644 L 470 712 L 464 719 L 459 722 L 452 724 L 444 724 L 433 720 L 425 713 L 310 526 L 309 510 L 313 491 L 320 470 L 332 446 L 338 441 L 345 438 L 353 437 L 367 441 L 377 450 L 391 474 L 399 484 L 426 422 L 441 383 L 444 377 L 453 369 L 458 367 L 472 367 L 483 372 L 492 381 L 512 413 L 526 383 L 558 305 L 567 297 L 577 295 Z"
            />
        </svg>
    );
}

export default WavelengthLogo;
